import { Injectable, inject } from '@angular/core';
import { Route, PreloadingStrategy } from '@angular/router';
import { Observable, of } from 'rxjs';
import type { UserRole } from '../models/session.model';
import { RoleService } from './role.service';

/**
 * Preloading strategy que respeta los roles de usuario.
 *
 * - Rutas sin `data.roles`: se precargan siempre (públicas/compartidas).
 * - Rutas con `data.roles`: solo se precargan si el rol actual está incluido.
 * - Rol no resuelto aún: no se precarga nada (seguro).
 *
 * Reemplaza `PreloadAllModules` en `main.ts`.
 * Un marketer en 3G no descarga los chunks de admin (POS, reports, CRUD).
 */
@Injectable({ providedIn: 'root' })
export class RoleAwarePreloadingStrategy extends PreloadingStrategy {
  private roleService = inject(RoleService);

  preload(route: Route, load: () => Observable<any>): Observable<any> {
    const routeRoles = route.data?.['roles'] as UserRole[] | undefined;

    // Sin restricción de rol → precargar (ruta pública/compartida)
    if (!routeRoles || routeRoles.length === 0) {
      return load();
    }

    const role = this.roleService.role();
    if (role && routeRoles.includes(role)) {
      return load();
    }

    return of(null);
  }
}
